import axios from 'axios';

const Api = {
  get(endpoint, params, next) {
    axios({
      method: 'get',
      url: endpoint,
      params: params,
    })
      .then(response => {
        next(response.data, false);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) next(false, error.response.status);
      });
  },
  post(endpoint, params, next) {
    axios
      .post(`${endpoint}`, params)
      .then(response => {
        next(response.data, false);
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) next(false, error.response.status);
      });
  },
  put(endpoint, params, next) {
    axios
      .put(`${endpoint}`, params)
      .then(response => {
        next(response.data, false);
      })
      .catch(error => {
        if (error.response) next(false, error.response.data);
      });
  },
  delete(endpoint, next) {
    axios
      .delete(`${endpoint}`)
      .then(response => {
        next(response.data, false);
      })
      .catch(function(error) {
        if (error.response) next(false, error.response.data);
      });
  },
};

export default Api;
